<div class="main-div">
    <div class="bg-div">
        <!--  <i class="fas fa-arrow-left back-btn" (click)="isBack()"></i> -->
        <img src="../../../../assets/icon/left-arrow.png" alt="" (click)="isBack()" class="back-btn">
        <h6>😔</h6>
        <h5>{{title}}</h5>
        <p innerHTML="{{desc1}}"></p>
    </div>
    <img src="../../../assets/images/win-star.svg" alt="" class="lucky-img">
    <div class="text-div">
        <p class="first-p">{{desc2}}</p>
        <p class="second-p">{{desc3}}</p>
        <h5>{{subTitle}}</h5>
        <p class="third-p">{{desc4}}</p>
        <button (click)="goToSyndicate()" class="view">{{buttonLabel}}</button>
    </div>
</div>
